// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#popover-link,#popover-root,#popover-share{width:80%;max-width:800px}#popover-link .popover-body,#popover-root .popover-body,#popover-share .popover-body{overflow-y:auto;overflow-x:hidden;max-height:80vh}#popover-link .stac-id .copy-button{padding-top:.1rem;padding-bottom:.1rem;font-size:.7rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
